import highlightRadioClasses from './ccf-radio-highlight.module.scss';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import React from 'react';
import Typography from '@mui/material/Typography';
import { CcfInfoIcon } from '../../icons/ccf-info-icon/ccf-info-icon';
import { CcfTooltip } from '../../core/ccf-tooltip/ccf-tooltip';
import { useTranslator } from '../../ccf-translator/ccf-translator';
import { Box, Theme, useTheme } from '@mui/material';
import ccfRadioHighlightStyles from './ccf-radio-highlight.style';
import { createStyles, makeStyles } from '@mui/styles';

interface RadioTypePref {
  data:  Array<{
    value: string;
    label: string;
    toolTipText:string;
  }>
  defaultSelected: string;
  showInfoIcon: boolean;
}

interface dataOptionType {
  value: string;
  label: string;
  toolTipText:string;
  showRadioOption: boolean;
}

export interface CcfRadioHighlightProps {
  onRadioButtonSelection: (e: React.ChangeEvent<HTMLInputElement>) => void;
  options:RadioTypePref;
}

/**
 * 
 * @param props - any
 * @example styledRadio(props)
 * @returns 
 */
function StyledRadio(props:any) {
  const useStyles =  makeStyles((theme: Theme) =>
    createStyles({
      checkedIconRad: {
        backgroundColor: `${theme?.palette?.info?.main} !important`,
        backgroundImage:
          'linear-gradient(180deg, hsla(0, 0%, 100%, 0.1), hsla(0, 0%, 100%, 0)) !important',
        '&::before': {
          width: '16px',
          height: '16px',
          content: '""',
          display: 'block',
          backgroundImage: `radial-gradient(
              ${theme?.palette?.background?.paper},
              ${theme?.palette?.background?.paper} 28%,
              transparent 32%
          )`,
        },
      },
      iconRad: {
        width: '16px',
        height: '16px',
        boxShadow: 'inset 0 0 0 1px rgb(16 22 26 / 20%), inset 0 -1px 0 rgb(16 22 26 / 10%)',
        borderRadius: '50%',
        backgroundColor: theme?.palette?.background?.callControlHeader,
        backgroundImage: 'linear-gradient( 180deg, hsla(0, 0%, 100%, 0.8), hsla(0, 0%, 100%, 0))',
      },
    })
  );
  const classes = useStyles();
  return (
    <div>
      <Radio
        className=""
        disableRipple
        color="default"
        checkedIcon={<span className={`${classes.checkedIconRad} ${classes.iconRad}`} />}
        icon={<span className={`${classes.iconRad}`} 
          id={props.id}/>}
        {...props}
      />
    </div>
  );
}

/**
 * 
 * @param props - any
 * @example <CcfRadioHighlight />
 * @returns 
 */
export function CcfRadioHighlight(props: any) {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      highlightLabelWithRadio: {
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiSvgIcon-root.infoIcon': {
          fontSize: '20px',
          color: theme?.palette?.text?.active,
          cursor: 'pointer',
          visibility: 'hidden',
          marginTop: '5px',
        },
        '& .MuiSvgIcon-root.showInfo.infoIcon': {
          visibility: 'visible',
        },
        '& .MuiTypography-body1': {
          fontSize: '14px',
        },
      },
      customBlue: {
        width: '220px',
        height: '30px',
        textAlign: 'left',
        borderRadius: '3px',
        color: theme?.palette?.text?.primary,
        backgroundColor: theme?.palette?.background?.paper,
        '& .MuiIconButton-label span': {
          width: '14px',
          height: '14px',
          backgroundColor: theme?.palette?.background?.paper,
        },
        '& input:hover ~ .MuiIconButton-label span': {
          backgroundColor: theme?.palette?.background?.paper,
        },
        '& .MuiIconButton-label span:before': {
          backgroundImage: `radial-gradient(
            ${theme?.palette?.text?.active},
            ${theme?.palette?.text?.active} 34%,
            transparent 51%
          )`,
          width: '14px',
          height: '14px',
        },
      },
      hightlightBlue: {
        background: theme?.palette?.text?.active,
        color: theme?.palette?.background?.paper,
      },
    })
  );
  const classes = useStyles();
  const {options, onRadioButtonSelection,id} = props;
  const [translate] = useTranslator();
  const theme = useTheme();
  const ccfRadioHighlightStyle = ccfRadioHighlightStyles(theme);

  /**
   * 
   * @example - renderTranslatedText()
   * @returns - translated format of the text
   */
  const renderTranslatedText = (labelText: string) => {
    switch (labelText) {
    case 'Set Phone Number':
      return translate('setPhoneNumber')
    case 'Set Station ID':
      return translate('setStationID')
    case 'Microsoft ACS':
      return translate('microsoftAcs')
    default:
      return translate('integratedSoftPhone')
    }
  };
  return (
    <div className={`${classes.highlightLabelWithRadio}`}>
      <RadioGroup
        aria-label="radio"
        name="highlightedRadio"
        value={options.defaultSelected}
        onChange={onRadioButtonSelection}
        id={id}
      >
        {options.data.map((option:dataOptionType, index:number) =>
          option.showRadioOption && (
            <Box sx={ccfRadioHighlightStyle.radioBox} key={index}>
              <FormControlLabel
                className={classes.customBlue}
                value={option.value}
                control={<StyledRadio id={option.value}/>}
                label= {renderTranslatedText(option.label)}
              
              />
              {/* <CcfTooltip tabIndex={0} aria-label={option.label}
                title={
                  <React.Fragment>
                    <Typography sx={ccfRadioHighlightStyle.tooltipHeader}>{renderTranslatedText(option.label)}</Typography>
                    {'Need custom data for it'}
                  </React.Fragment>
                }
                arrow
                placement="right"  
                disableInteractive              
              >
                <div>
                  <CcfInfoIcon htmlColor="" className={options.showInfoIcon && options.defaultSelected === option.value ? 'showInfo infoIcon' : 'infoIcon'}></CcfInfoIcon>
                </div>
              </CcfTooltip> */}
            </Box>             
          ))}
      </RadioGroup>
    </div>
  );
}

export default CcfRadioHighlight;
